// extracted by mini-css-extract-plugin
module.exports = {"input":"FieldCurrencyInput_input__31ylu","inputSuccess":"FieldCurrencyInput_inputSuccess__3Bnmc","inputError":"FieldCurrencyInput_inputError__BUDs_"};